// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36Z8K","questions":"styles_questions__SVawu","footer":"styles_footer__1Iogl"};